"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importStar(require("react"));
const alert_styles_1 = require("./alert.styles");
const Info = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/info'))));
const Alert = ({ title, description, type, icon, testId = 'alert', }) => (react_1.default.createElement(alert_styles_1.StyledAlert, { type: type },
    react_1.default.createElement(alert_styles_1.StyledIcon, { "data-testid": `${testId}-icon`, type: type }, icon || (react_1.default.createElement(react_1.Suspense, { fallback: null },
        react_1.default.createElement(Info, { width: 24, color: "currentColor" })))),
    (title || description) && (react_1.default.createElement(alert_styles_1.StyledAlertContent, { type: type },
        title && (react_1.default.createElement(alert_styles_1.StyledAlertTitle, { "data-testid": `${testId}-title` }, title)),
        description && (react_1.default.createElement(alert_styles_1.StyledAlertText, { "data-testid": `${testId}-description`, type: type }, description))))));
exports.Alert = Alert;
